<template>
  <div>
    <pc-dialog title="登录" :visible.sync="dialogVisible" @close="close" @confirm="handleReserve">
      <template #content>
        <form class="form">
          <div class="form__item required">
            <label class="form__label" for="os">
              <span>平台</span>
              <span>：</span>
            </label>
            <div class="radio-group">
              <div class="radio">
                <input id="android" type="radio" :value="0" v-model="form.os" /><label for="android">安卓</label>
              </div>
              <div class="radio">
                <input id="ios" type="radio" :value="1" v-model="form.os" /><label for="ios">IOS</label>
              </div>
            </div>
          </div>
          <div class="form__item required">
            <label class="form__label" for="phone">
              <span>手机号</span>
              <span>：</span>
            </label>
            <input id="phone" type="text" v-model="form.phone" autocomplete="off" />
          </div>
          <div class="form__item required" v-if="needVerifyCode">
            <label class="form__label" for="captcha">
              <span>图形验证码</span>
              <span>：</span>
            </label>
            <input id="captcha" type="text" v-model="form.captcha" autocomplete="off" />
            <img class="captcha" :src="captcha" @click="getCaptchaInfo" />
          </div>
          <div class="form__item required">
            <label class="form__label" for="code">
              <span>手机验证码</span>
              <span>：</span>
            </label>
            <input id="code" type="text" v-model="form.code" autocomplete="off" />
            <div
              class="code-btn"
              :class="{ disabled: countdown > 0 }"
              @click="sendPhoneCode"
            >获 取<span v-if="countdown > 0">({{ countdown }})</span></div>
          </div>
          <div class="form__item">
            <label class="form__label" for="inviteCode">
              <span>邀请码</span>
              <span>：</span>
            </label>
            <input id="inviteCode" type="text" v-model="form.invite_code" autocomplete="off" />
          </div>
        </form>
      </template>
      <template #tips><div class="tips">*点击“确认”代表您同意我们向您的手机号发送短信通知或以手机号参与活动。</div></template>
    </pc-dialog>
  </div>
</template>

<script>
import PcDialog from '../dialog/Index.vue'

import reserveDialogMixins from '@/mixins/reserveDialogMixins'

export default {
  name: 'PcReserveDialog',
  mixins: [reserveDialogMixins],
  components: {
    PcDialog,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/pc/form.scss';

.tips {
  color: #282828;
}
</style>